/**
 * Untyped Supabase client for tables not yet in generated types.
 * Use this temporarily until types are regenerated after migration.
 */
import { supabase } from "@/integrations/supabase/client";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const db = supabase as any;
